import { ClaimIntegrationControllerApi, ClaimIntegrationDto } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author Atish Bagate
 */

interface Params {
  claimIntegration: ClaimIntegrationDto;
  xTENANTID?: string;
}

export const useUpdateClaimIntegration = () =>
  useMutationWithLoading(async (params: Params) =>
    new ClaimIntegrationControllerApi(getConfigObject()).updateConfiguration1(
      params.claimIntegration,
      params.xTENANTID
    )
  );
